import cloneDeep from 'lodash/cloneDeep';
var _convertObjectUndefinedNull = function (obj) {
    if (obj === undefined) {
        return null;
    }
    if (typeof obj === 'object') {
        if (obj instanceof Map) {
            obj.forEach(function (value, key) { return obj.set(key, _convertObjectUndefinedNull(value)); });
        }
        else {
            for (var key in obj) {
                var k = key;
                obj[k] = _convertObjectUndefinedNull(obj[k]);
            }
        }
    }
    return obj;
};
var convertObjectUndefinedNull = function (obj) {
    return _convertObjectUndefinedNull(cloneDeep(obj));
};
export default convertObjectUndefinedNull;
//# sourceMappingURL=convert-object-undefined-null.js.map